import { render, staticRenderFns } from "./CallUiCategoriesItem.vue?vue&type=template&id=09053721&scoped=true"
import script from "./CallUiCategoriesItem.vue?vue&type=script&lang=js"
export * from "./CallUiCategoriesItem.vue?vue&type=script&lang=js"
import style0 from "./CallUiCategoriesItem.vue?vue&type=style&index=0&id=09053721&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09053721",
  null
  
)

export default component.exports